/**
 * NOTIF — docs/03 §3.9.
 *
 * The snapshot half of the `notifications` channel: read once at cold load to
 * render the bell badge, then maintained from the stream. Deposit credits,
 * withdrawal state changes and reward accruals all arrive this way, which is why
 * none of those three screens polls anything (§8.4).
 *
 * `POST /notifications/read` is **batched**: one request per tray-open marking
 * the visible set, never one request per item.
 */

import type { HttpClient, MutationOptions, RequestOptions } from '../client'
import type { OkBody, Page, OpBody, OpQuery } from '../types'

export function notificationEndpoints(client: HttpClient) {
  return {
    listNotifications(query?: OpQuery<'listNotifications'>, options?: RequestOptions) {
      return client.get<Page<OkBody<'listNotifications'>>>('/notifications', { ...options, query })
    },

    markNotificationsRead(body: OpBody<'markNotificationsRead'>, options?: MutationOptions) {
      return client.post<OkBody<'markNotificationsRead'>>('/notifications/read', body, options)
    },
  }
}

export type NotificationEndpoints = ReturnType<typeof notificationEndpoints>
